import {remCalc} from '_themeUtils'

const spacing = {
    none: '0',
    px: remCalc(1),
    0.5: remCalc(2),
    1: remCalc(4),
    1.5: remCalc(6),
    2: remCalc(8),
    2.5: remCalc(10),
    3: remCalc(12),
    3.5: remCalc(14),
    4: remCalc(16),
    5: remCalc(20),
    6: remCalc(24),
    7: remCalc(28),
    8: remCalc(32),
    9: remCalc(36),
    10: remCalc(40),
    11: remCalc(44),
    12: remCalc(48),
    14: remCalc(56),
    15: remCalc(60),
    16: remCalc(64),
    20: remCalc(80),
    22: remCalc(88),
    24: remCalc(96),
    25: remCalc(100),
    28: remCalc(112),
    32: remCalc(128),
    36: remCalc(144),
    40: remCalc(160),
    44: remCalc(176),
    48: remCalc(192),
    52: remCalc(208),
    56: remCalc(224),
    60: remCalc(240),
    64: remCalc(256),
    72: remCalc(288),
    80: remCalc(320),
    96: remCalc(384),
}

const padding = {
    horizontal: {
        grid3: {base: 0, sm: spacing[4], xl: spacing[8]},
        grid2: {base: 0, sm: spacing[4], xl: spacing[8]},
    },
    vertical: {
        gridTop: {base: spacing[3], sm: spacing[6], xl: spacing[10]},
        gridBottom: spacing[22],
        sm: spacing[2],
        md: spacing[3],
        '3xl': spacing[8],
    },
}

const gap = {
    horizontal: {
        grid3: {base: spacing[1], md: spacing[4]},
        grid2: {base: spacing[1], sm: spacing[4]},
    },
}

export {spacing, padding, gap}
